import React, { useState, useEffect, useMemo } from 'react';
import './Call.scss'
import { AxpOmniSdk } from "@avaya/axp-omni-sdk-core";
import { v4 as uuidv4 } from 'uuid';
import { AxpCallingConversation, AxpCallRequestBuilder } from "@avaya/axp-omni-sdk-calling";
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { voiceBBCard, endVoiceBBCard } from '../../services';

const CallWrapper = styled.div`
    height: 100%;
    padding: 10px;
`;

const VISIT_TIMEOUT = 20 * 60 * 1000; // 20 minutes in milliseconds

const checkVisitedCustomer = (username) => {
    const storedData = JSON.parse(localStorage.getItem('visitedCustomer')) || {};
    const { username: storedUsername, lastVisit } = storedData;

    if (storedUsername === username && Date.now() - lastVisit <= VISIT_TIMEOUT) {
        return true;
    }
    
    return false;
};

const pLangValMapping = {
    "IN_Dafa_CS_WEB_REG": "+63284248260",
    "HI_Dafa_CS_WEB_REG": "+63284248259",
    "TE_Dafa_CS_WEB_REG": "+63284248258",
    "HI_Dafa_CS_Arion_REG": "+63284248256",
    "TE_Dafa_CS_Arion_REG": "+63284248255",
    "IN_Dafa_CS_Arion_REG": "+63284248257",
    "TH_Zedbet_CS_WEB_REG": "+63284248262",
    "BD_Dafa_CS_WEB_REG": "+63284248249",
    "BG_Dafa_CS_WEB_RE": "+63284248249",
    "SC_Dafa_CS_WEB_REG": "+63284248250",
    "SC_Dafa_CS_Arion_REG": "+63284248250",
    "SC_Dafa_CS_WEB_Elite": "+63284248251",
    "SC_Dafa_CS_Arion_Elite": "+63284248251",
    "SC_Dafa_CS_WEB_VIP": "+63284248252",
    "SC_Dafa_CS_Arion_VIP": "+63284248252",
    "TE_Dafa_CS_Pre_Prod_Arion_REG": "+63284248248",
    "HI_Dafa_CS_Pre_Prod_Arion_REG": "+63284248253",
    "IN_Dafa_CS_Pre_Prod_Arion_REG": "+63284248254"
};

const generatePLangVal = (params, playerData, visitedCustomer, brandName) => {
    
    let lang = params.get('lang')?.toUpperCase() || "IN";
    if (lang === "EN") lang = "IN";
    if (brandName === "Zedbet") lang = "TH";

    let backPart = "CS_WEB_REG";
    if (playerData?.username) {
        backPart = visitedCustomer ? "CS_WEB_REG" : "CS_Arion_REG";

        if (brandName === "Zedbet") backPart = "CS_WEB_REG";
        if (lang === "SC" && (params.get('level') === "13" || params.get('level') === "18")) {
            backPart = "CS_Arion_Elite";
        }
    }
    console.log(lang, brandName, params.get('level'));
    if ((window.location.hostname === "istg-chat.elysium-dfbt.com" || window.location.hostname === "localhost") && lang !== "SC") {
        backPart = "CS_Pre_Prod_Arion_REG";
    }

    return [lang, brandName, backPart].join("_");
};

const config = {
    integrationId: process.env.REACT_APP_INTEGRATION_ID,
    appKey: process.env.REACT_APP_APP_KEY,
    axpHostName: process.env.REACT_APP_AXP_HOST_NAME,
    callingRemoteAddress: process.env.REACT_APP_CALLING_REMOTE_ADDRESS,
};

const webRtcServerURL = process.env.REACT_APP_WEBRTC_SERVER_URL;

class JwtProviderImpl {
    userId = uuidv4();
    user = {
        userName: "Guest",
        userId: this.userId,
        verified: true,
        userIdentifiers: {
            emailAddresses: [this.userId + "@example.com"],
        },
    };

    async fetchToken() {
        const response = await fetch(webRtcServerURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(this.user),
        });
        const responseJson = await response.json();
        return responseJson.jwtToken;
    }

    onExpire() {
        console.log("JWT has expired");
    }

    onExpireWarning(remainingTime) {
        console.log("JWT will expire in " + remainingTime);
    }
}
const jwtTokenProvider = new JwtProviderImpl();


const Call = () => {
    const [call, setCall] = useState(null);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isCallEnded, setIsCallEnded] = useState(false); // State to check if the call has ended.
    const [localStream, setLocalStream] = useState(null);
    const { engagement, user, ui, common } = useSelector(state => state);
    const configUI = ui.config.attributes;
    const webRTC = configUI?.WebRTC;
    const playerData = ui.player?.data ? ui.player?.data.attributes : null;
    const [isMuted, setIsMuted] = useState(false);
    const [elapsedTime, setElapsedTime] = useState(0); // Timer state
    const product = 'Some Product'; // Adjust according to actual product
    let bbc_id = null;
    let language = configUI?.locale.toUpperCase();
    language = (language == "en-IN") ? "IN" : language;
    const brand = 'Dafabet'; // Set to desired brand
    const visitedCustomer = checkVisitedCustomer((playerData) ? playerData.username : '');

    const brandName = window.location.pathname.split("/")[4]?.charAt(0).toUpperCase() +
    window.location.pathname.split("/")[4]?.slice(1) || "Dafa";

    const params = new URLSearchParams(window.location.search);
    const pLangVal = useMemo(() => {
        return generatePLangVal(params, playerData, visitedCustomer, brandName);
    }, [params, playerData, visitedCustomer, brandName]);
    const callingRemoteAddress = pLangValMapping[pLangVal] || "";
    console.log(callingRemoteAddress, pLangVal);
    const customValues = [
        { title: 'IP', value: configUI?.PreChatSurvey?.clientIp || '202.151.35.161' },
        { title: 'country', value: configUI?.PreChatSurvey?.countryCode || '' },
        { title: 'referer', value: user?.referer },
        { title: 'RefererPlatform', value: user?.refererPlatform },
        { title: 'CustomerVerified', value: playerData ? "true" : "false" },
        { title: 'language', value: language || 'EN' },
        { title: 'CustomerSegment', value: 'false' },
        { title: 'SuggestedPM', value: user?.payment },
        { title: 'OtherPM', value: user.opm },
        { title: 'Restart', value: 'false' },
        { title: 'skillset', value: 'WC_EN_Dafa_Casino_REG_PT' },
        { title: 'username', value: (playerData) ? playerData.username : '' },
        { title: 'name', value: (playerData) ? playerData.username : '' },
        { title: 'email', value: (playerData) ? playerData.email : 'test@dfbt.com' },
        { title: 'phoneNumber', value: '' },
        { title: 'product', value: product },
        { title: 'inquiry', value: "" },
        { title: 'subinquiry', value: "" },
        { title: 'deposit', value: "" },
    ];

    let engagementParamters = { Brand: brand };
    customValues.forEach((item) => {
        engagementParamters = { ...engagementParamters, [item.title]: item.value };
    });

    useEffect(() => {
        navigator.mediaDevices.getUserMedia({ audio: true, video: false })
            .then(stream => setLocalStream(stream))
            .catch(error => console.error("Error accessing microphone:", error));
    }, []);

    const toggleMute = () => {
        if (localStream) {
            const audioTracks = localStream.getAudioTracks();
            if (audioTracks.length > 0) {
                const isCurrentlyMuted = !audioTracks[0].enabled;
                audioTracks[0].enabled = isCurrentlyMuted;
                console.log(isCurrentlyMuted ? "Microphone unmuted" : "Microphone muted");
                setIsMuted(!isCurrentlyMuted);
            }
        }
    };

    const initiateCallBBCard = async () => {
        bbc_id = await voiceBBCard({...engagementParamters, "channel_type": "voice"});
        console.log("voiceBBCard executed");
    };

    const initiateCallEndBBCard = async () => {
        await endVoiceBBCard({bbc_id: bbc_id});
        console.log("voiceBBCardEND executed");
    };

    useEffect(() => {
        let timer;

        if (call) {
            timer = setInterval(() => {
                setElapsedTime(prevTime => prevTime + 1);
            }, 1000);
        }

        return () => {
            clearInterval(timer);
        };
    }, [call]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60).toString().padStart(2, '0');
        const secs = (seconds % 60).toString().padStart(2, '0');
        return `${minutes}:${secs}`;
    };
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const sessionCode = urlParams.get('s');

        if (sessionCode) {
            setIsAuthorized(true);
            const initCall = async () => {
                try {
                    const axpSession = await AxpOmniSdk.init(
                        {
                            displayName: "Guest",
                            token: await jwtTokenProvider.fetchToken(),
                            integrationId: config.integrationId,
                            host: config.axpHostName,
                            appKey: config.appKey,
                            logLevel: config.loglevel,
                            jwtProvider: jwtTokenProvider,
                        },
                        AxpCallingConversation(),
                    );

                    const conversation = axpSession.conversations[0];
                    let call;
                    const muteAudio = false;
                    


                    const requestBuilder = new AxpCallRequestBuilder();
                    if (muteAudio) {
                        requestBuilder.muteAudio();
                    }
                    requestBuilder.setRemoteAddress(callingRemoteAddress);
                    call = await conversation.addCall(requestBuilder.build(), setupCallMonitoring);


                    function setupCallMonitoring(c) {
                        call = c;

                        c.addOnCallEstablishedCallback(() => {
                            setCall(call);
                            initiateCallBBCard(); // Call once the call is established

                            console.log("*** Call Established");
                            
                            console.log("Conversation created:", axpSession);
                        });

                        c.addOnCallFailedCallback((call, exception) => {
                            console.log("*** Call Failed: " + exception.getError());
                            call.end();
                        });

                        c.addOnCallEndedCallback((c, evt) => {
                            console.log("*** Call Ended: " + evt.getReason() + ";" + evt.getReasonText());
                            
                            initiateCallEndBBCard();

                            setCall(null); // Clear the active call
                            setIsCallEnded(true); // Set the call ended state

                            // Update localStorage with the username and timestamp
                            if (playerData?.username && playerData?.username != "") {
                                alert(playerData?.username);
                                localStorage.setItem(
                                    'visitedCustomer',
                                    JSON.stringify({ username: playerData.username, lastVisit: Date.now() })
                                );
                            }
                        });

                        c.addOnMediaConnectedCallback(() => {
                            console.log("*** Media Connected");
                        });

                        c.addOnMediaFailedCallback(() => {
                            console.log("*** Media Failed");
                            call.end();
                        });

                        c.addOnMediaDisconnectedCallback(() => {
                            console.log("*** Media Disconnected");
                        });
                    }
                } catch (error) {
                    console.error("Error during call initialization:", error);
                }
            };

            initCall();
        } else {
            setIsAuthorized(false);
        }
    }, [callingRemoteAddress]);

    const endCall = () => {
        if (call) {
            call.end();
            console.log("Call ended");
        } else {
            console.log("No active call to end");
        }
    };

    return (
        <>
            <div className='main'>
                {isAuthorized ? (
                    !isCallEnded ? (
                        <div id="call-action" className="page-container">
                            <div className="status-label">
                                {call ? 
                                    <p id="call-status">{ formatTime(elapsedTime) }</p>
                                    : 
                                    <p id="connecting-label">{webRTC?.ConnectingText ? webRTC?.ConnectingText : "Connecting"}</p>
                                }
                                <p id="msg-label"></p>
                            </div>
                            <div className="icons">
                                {/* Call buttons */}
                                <button
                                    type="button"
                                    className={`btn-call-icon ${isMuted ? '' : 'active'}`}
                                    id="btn-mute-call"
                                    onClick={toggleMute}
                                >
                                    <img alt={isMuted ? "Unmute" : "Mute"} src={"/assets/images/call/unmute.png"} />
                                </button>
                                <button type="button" className="btn-call-icon" id="btn-pause-call" disabled>
                                    <img alt="Pause" src={"/assets/images/call/pause.png"} />
                                </button>
                                <button type="button" className="btn-call-icon" id="btn-speaker" disabled>
                                    <img alt="Volume" src={"/assets/images/call/volume.png"} />
                                </button>
                            </div>
                            <div className="call-button">
                                <button type="button" id="btn-end-call" onClick={endCall}>
                                    <img alt="End Call" id="call-btn-icon" src={"/assets/images/call/connecting.png"} />
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div id="call-ended" className="page-container">
                            <h1>{webRTC?.thanks1 ? webRTC?.thanks1 : "Thank you"}</h1>
                            <h1>{webRTC?.thanks2 ? webRTC?.thanks2 : "for calling Dafabet"}</h1>

                            <p id="lbl-call-again">Place another call</p>

                            <div className="call-button">
                                <button type="button" id="btn-call-again" style={{display: "inline-block"}} onClick={() => window.location.reload()}>
                                    <img alt="Call Again" src={"/assets/images/call/call-again.png"} />
                                </button>
                            </div>
                        </div>
                    )
                ) : (
                    <div id="none-auth" className="page-container">
                        <h1>{webRTC?.UnAuthWndowText ? webRTC?.UnAuthWndowText : "Please login first to make a call."}</h1>
                        <a className="login-btn" href={webRTC?.UnAuthChatUrl ? webRTC?.UnAuthChatUrl : "#"} target="_blank">Login</a>
                        <p className="contact-text">{webRTC?.UnAuthWndowText2 ? webRTC?.UnAuthWndowText2 : "Contact 24x7 Chat Support"}</p>
                        <a className="chat-btn" target='_default' href={webRTC?.UnAuthChatUrl ? webRTC?.UnAuthChatUrl : "#"}>
                            <i className="fa fa-comments"></i> {webRTC?.UnAuthChatButtonText ? webRTC?.UnAuthChatButtonText : "24/7 Live Chat"}
                        </a>
                    </div>
                )}
            </div>
        </>
    );
};

export default Call;
